import { SVGProps } from '@components/Icon/types';

export const Notification = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2.5, 2)">
      <path
        d="M0.403922 6.36345C0.446565 6.37426 0.490985 6.37966 0.533629 6.37966C0.771721 6.37966 0.990269 6.21572 1.05068 5.97069C1.54463 3.96728 2.72088 2.19267 4.36087 0.978373C4.59897 0.801813 4.65049 0.464907 4.47637 0.223489C4.30224 -0.0179298 3.96998 -0.0701771 3.73188 0.106383C1.89111 1.47022 0.570942 3.45922 0.0165776 5.70946C-0.0562715 5.99772 0.117856 6.29138 0.403922 6.36345ZM14.6397 0.978373C16.2797 2.19267 17.4542 3.96548 17.9499 5.97069C18.0103 6.21572 18.2271 6.37966 18.467 6.37966C18.5096 6.37966 18.554 6.37426 18.5967 6.36345C18.8827 6.29138 19.0551 5.99772 18.984 5.70765C18.4296 3.45922 17.1095 1.46842 15.2687 0.104581C15.0306 -0.0719787 14.6983 -0.0197314 14.5242 0.221687C14.3501 0.464908 14.4016 0.801813 14.6397 0.978373ZM1.5393 14.3879C1.36518 15.0924 1.51798 15.8256 1.96041 16.3967C2.40105 16.9697 3.06558 17.2976 3.78163 17.2976H6.3509C6.60498 18.8289 7.91982 20 9.50118 20C11.0825 20 12.3956 18.8289 12.6515 17.2976H15.2207C15.9368 17.2976 16.6013 16.9697 17.042 16.3967C17.4826 15.8238 17.6354 15.0924 17.4631 14.3879L15.5352 6.58325C14.8423 3.7691 12.3601 1.80352 9.4994 1.80352C6.63874 1.80352 4.15654 3.7691 3.46359 6.58325L1.5393 14.3879ZM9.4994 18.919C8.50794 18.919 7.67462 18.229 7.43653 17.2976H11.5605C11.3242 18.229 10.4909 18.919 9.4994 18.919ZM9.4994 2.8845C11.8697 2.8845 13.9272 4.51317 14.5011 6.84448L16.4254 14.6492C16.5196 15.0293 16.4361 15.4221 16.1997 15.7319C15.9617 16.04 15.6045 16.2166 15.219 16.2166H3.77986C3.39429 16.2166 3.03715 16.04 2.79906 15.7319C2.56097 15.4239 2.47923 15.0293 2.57341 14.6492L4.49769 6.84448C5.0716 4.51317 7.12914 2.8845 9.4994 2.8845Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'notification';
